import { SliceStatus } from 'type-declarations';

export const isStatusIdleOrPending = (status: SliceStatus[]): boolean => {
	return status.includes(SliceStatus.IDLE) || status.includes(SliceStatus.PENDING);
};

export const isStatusPendingOrRefreshing = (status: SliceStatus[]): boolean => {
	return status.includes(SliceStatus.PENDING) || status.includes(SliceStatus.REFRESHING);
};
